import React from "react";
import { Link } from "@tanstack/react-router";
import {
  MailOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";

type FooterLink = {
  label: string;
  to?: string;
  href?: string;
};

type FooterColumn = {
  title: string;
  links: FooterLink[];
};

const footerColumns: FooterColumn[] = [
  {
    title: "Product",
    links: [
      {
        label: "Schedules",
        href: "/schedules",
      },
      {
        label: "History",
        href: "/list",
      },
      {
        label: "Youtube",
        href: "/youtube",
      },
      {
        label: "Player",
        to: "/player",
      },
    ],
  },
  {
    title: "Legal & Contact",
    links: [
      {
        label: "Privacy Policy",
        to: "/privacy-policy",
      },
      
      {
        label: "Khan Global Studies",
        href: "https://khanglobalstudies.com",
      },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-[#1D1F5D] text-white">

      <div className="mx-auto max-w-[1440px] px-5 py-12 sm:px-8 lg:px-10 lg:py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr] lg:gap-16">
          <div className="max-w-md">
            <Link
              to="/"
              className="inline-flex items-center gap-3 no-underline"
            >
              <img
                src="/kgs-studio.png"
                alt="KGS Studio"
                className="h-11 w-auto object-contain"
              />
            </Link>

            <p className="mt-2 text-sm leading-6 text-white/65">
              KGS Studio is a video and live-stream management
              platform developed and operated by{" "}
              <strong className="font-semibold text-white/85">
                Khan Global Studies
              </strong>
              .
            </p>

            <p className="mt-2 text-sm leading-6 text-white/65">
              Built for authorized creators and team members to manage
              educational video publishing and live broadcasts.
            </p>
            <a
              href="mailto:enquiry@khanglobalstudies.com"
              className="mt-2 inline-flex items-center gap-2 text-sm font-medium text-white/75 no-underline transition-colors hover:text-[#00B86B]"
            >
              <MailOutlined />
              Contact KGS Studio
            </a>
          </div>

        
          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-bold text-white">
                {column.title}
              </h3>

              <div className="mt-2 flex flex-col gap-3">
                {column.links.map((link) => {
                  if (link.to) {
                    return (
                      <Link
                        key={link.label}
                        to={link.to}
                        className="text-sm text-white/60 no-underline transition-colors hover:text-[#00B86B]"
                      >
                        {link.label}
                      </Link>
                    );
                  }

                  return (
                    <a
                      key={link.label}
                      href={link.href}
                      target={
                        link.href?.startsWith("http") ? "_blank" : undefined
                      }
                      rel={
                        link.href?.startsWith("http")
                          ? "noopener noreferrer"
                          : undefined
                      }
                      className="text-sm text-white/60 no-underline transition-colors hover:text-[#00B86B]"
                    >
                      {link.label}
                    </a>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-4 px-5 py-5 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:px-10">
          <p className="m-0 max-w-4xl text-xs leading-5 text-white/45">
            © {new Date().getFullYear()} Khan Global Studies. KGS Studio is a
            product of Khan Global Studies. YouTube is a trademark of Google
            LLC. KGS Studio uses YouTube&apos;s official APIs and is not
            endorsed by or affiliated with Google LLC.
          </p>

          <div className="flex shrink-0 items-center gap-4">
           

            <button
              type="button"
              onClick={() =>
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                })
              }
              aria-label="Back to top"
              className="flex h-9 w-9 items-center justify-center rounded-lg border-0 bg-white/5 text-white/60 transition-all hover:bg-white/10 hover:text-white"
            >
              <ArrowUpOutlined />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;